<div class="fixed inset-0 z-[70] flex items-center justify-center p-4">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" (click)="close.emit(false)"></div>

  <!-- Modal Content -->
  <div class="relative w-full max-w-2xl bg-white rounded-3xl shadow-2xl overflow-hidden animate-slide-up flex flex-col max-h-[90vh]">
    <!-- Header -->
    <div class="p-6 border-b border-slate-100 flex justify-between items-center bg-white sticky top-0 z-10">
      <div>
        <h3 class="text-xl font-black text-slate-800 uppercase tracking-widest">
          {{ 'modal_import_health_plan_procedures_title' | translate }}
        </h3>
        <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">{{ 'modal_import_health_plan_procedures_subtitle' | translate }}</p>
      </div>
      <button (click)="close.emit(false)" class="p-2 hover:bg-slate-50 rounded-xl transition-colors text-slate-400 hover:text-slate-600">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto p-8">
      <a href="https://pkqviipqnvoaxmahlblq.supabase.co/storage/v1/object/public/procedures//templateseguradora.xlsx"
        target="_blank"
        class="inline-flex items-center gap-2 text-xs font-black text-primary uppercase tracking-widest mb-6 hover:underline">
        <i class="pi pi-download"></i>
        {{ 'modal_import_health_plan_procedures_template' | translate }}
      </a>

      <!-- Upload Area -->
      <div
        class="border-4 border-dashed border-slate-100 rounded-3xl p-16 text-center hover:border-primary/30 hover:bg-primary/5 transition-all cursor-pointer relative bg-slate-50/50 group"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
        (click)="fileInput.click()"
      >
          <input
            type="file"
            #fileInput
            class="hidden"
            accept=".xlsx, .xls"
            (change)="onFileSelected($event)"
          >

          <div *ngIf="!loading && !uploadSuccess && !errorMessage" class="animate-fadeIn">
             <div class="flex justify-center mb-6">
                <div class="w-16 h-16 rounded-2xl bg-white border border-slate-100 shadow-sm flex items-center justify-center text-primary group-hover:scale-110 transition-transform">
                  <svg class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                  </svg>
                </div>
             </div>
             <p class="text-lg text-slate-800 font-black uppercase tracking-widest">{{ 'modal_add_procedures_dropzone' | translate }}</p>
             <p class="text-xs text-slate-400 font-bold uppercase tracking-widest mt-2">{{ 'modal_add_procedures_dropzone_hint' | translate }}</p>
          </div>

          <!-- Loading State -->
          <div *ngIf="loading" class="flex flex-col items-center justify-center animate-fadeIn">
            <div class="relative w-16 h-16 mb-6">
              <div class="absolute inset-0 border-4 border-slate-100 rounded-full"></div>
              <div class="absolute inset-0 border-4 border-t-primary rounded-full animate-spin"></div>
            </div>
            <p class="text-slate-800 font-black uppercase tracking-widest text-lg">{{ 'modal_add_procedures_loading' | translate }}</p>
          </div>

          <!-- Success State -->
          <div *ngIf="uploadSuccess" class="flex flex-col items-center justify-center animate-fadeIn text-center">
             <div class="w-16 h-16 rounded-full bg-success/10 border border-success/20 flex items-center justify-center text-success mb-6">
               <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
               </svg>
             </div>
             <p class="text-success font-black uppercase tracking-widest text-lg">{{ 'modal_add_procedures_success' | translate }}</p>
          </div>

          <!-- Error State -->
          <div *ngIf="errorMessage" class="flex flex-col items-center justify-center animate-fadeIn text-center">
             <div class="w-16 h-16 rounded-full bg-danger/10 border border-danger/20 flex items-center justify-center text-danger mb-6">
               <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6 18L18 6M6 6l12 12"></path>
               </svg>
             </div>
             <p class="text-danger font-black uppercase tracking-widest text-lg">{{ errorMessage }}</p>
             <button (click)="errorMessage = null" class="mt-6 px-6 py-2 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-xl text-[10px] font-black uppercase tracking-widest transition-colors">
                {{ 'button_back' | translate }}
             </button>
          </div>
      </div>
    </div>
  </div>
</div>
